import React, { FC } from "react";

import { GenericAppointmentPage } from "./Pages/GenericAppointmentPage";
import { InsuranceLabelsContext } from "./Utils/Context/labelsContext";
import { InsuranceFiltersContext } from "./Utils/Context/filtersContext";
import { GenericAppointmentParams } from "../../Pages/GenericAppointment/GenericAppointmentParams.csharp";

export const InsuranceGenericAppointment: FC<GenericAppointmentParams> = (
  props
) => {
  return (
    <InsuranceLabelsContext labels={props.insuranceLabels}>
      <InsuranceFiltersContext>
        <GenericAppointmentPage {...props} />
      </InsuranceFiltersContext>
    </InsuranceLabelsContext>
  );
};
